import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { TwoFactorGateDialogComponent } from './two-factor-gate-dialog.component';
import { TwoFactorGateDialogStateService } from '../../../../services/auth/two-factor-gate-dialog-state.service';

/**
 * The two-factor enrollment gate, mounted once at the app root. `SuperUser2faGuard` asks it on the
 * way into the app, before any route component exists, so it cannot live in a caller's template.
 *
 * Created per opening (`*ngIf`), so the step, the copy and the recovery-codes lock start fresh.
 */
@Component({
    selector: 'app-two-factor-gate-dialog-host',
    standalone: true,
    imports: [NgIf, TwoFactorGateDialogComponent],
    template: `
        <app-two-factor-gate-dialog *ngIf="gate.open()" [open]="gate.open()" [reason]="gate.reason()" (closed)="gate.answer($event)"></app-two-factor-gate-dialog>
    `,
})
export class TwoFactorGateDialogHostComponent {
    constructor(readonly gate: TwoFactorGateDialogStateService) {}
}
